import React, { PureComponent } from 'react';
import styles from './index.less';
import LoadingIcon from '@src/components/image-with-loading/components/loading-icon';
import cx from 'classnames';

/**
 * 有加载动画的Image组件
 * <ImageWithLoading imgUrl={require('./images/no-poster-img.png')} />
 */
export default class ImageWithLoading extends PureComponent {
  constructor(props) {
    super(props);
    this.timer = React.createRef();
    this.state = {
      isLoading: true,
      forceDisplayImage: false
    };
  }

  handleImageLoaded = () => {
    const { callback } = this.props;
    this.setState({ isLoading: false });
    // console.log('加载成功');
  };

  componentDidMount() {
    const { imgUrl } = this.props;
    let that = this;
    let imgNode = new Image();
    imgNode.src = imgUrl;
    imgNode.onload = function() {
      // 说明图片image加载完成了
      // 将加载完成的image添加到images中
      setTimeout(() => {
        that.setState({ isLoading: false });
      }, Math.floor(Math.random() * (1000 - 800 + 1)) + 1000); // 过渡的动画时间 是使用800毫秒到1000毫秒之间的随机数
    };
    /**
     * 有时会出现loading的Icon一直处于显示的状态
     * 为了确保图片一定能显示 设置了一个定时器时长5秒 5秒后如果还是没有显示 直接将isLoading设置为false
     * @type {number}
     */
    this.timer.current = setTimeout(() => {
      that.setState({ forceDisplayImage: true });
    }, 5000);
  }

  componentWillUnmount() {
    this.setState = () => false;
  }

  render() {
    const { imgUrl, alt } = this.props;
    const { forceDisplayImage, isLoading } = this.state;
    if (!imgUrl) {
      return null;
    }
    if (forceDisplayImage) {
      return <img className={cx(styles.imgBox)} src={imgUrl} alt={alt} />;
    }
    if (isLoading) {
      return <LoadingIcon />;
    }
    return <img className={cx(styles.imgBox)} ref={n => (this.img = n)} src={imgUrl} alt={alt} onLoad={this.handleImageLoaded} />;
  }
}
